"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable*/
exports.default = {
  "login": {
    "onlineTraining": "Платформа онлайн-обучения Liaogao e Academy",
    "captchaNotEmpty": "код подтверждения должен быть заполнен",
    "accountNotEmpty": "Аккаунт не может быть пустым",
    "passwordBits": "Длина пароля не может быть меньше 6 цифр.",
    "incorrectTips": "Имя пользователя или пароль введены неверно",
    "sign": "авторизоваться",
    "passwordNotEmpty": "пароль не может быть пустым",
    "passwordBitsLong": "Длина пароля не может быть больше 18 цифр.",
    "captchaTips": "неверный код подтверждения",
    "confirmNot": "Введенный пароль не соответствует подтвержденному паролю",
    "inputAccount": "Пожалуйста, введите имя пользователя",
    "inputPassword": "Пожалуйста введите пароль",
    "inputCaptcha": "введите проверочный код",
    "forgetPassword": "забыть пароль",
    "nextStep": "Следующий шаг",
    "inputUserName": "введите имя пользователя",
    "phoneNumber": "телефонный номер",
    "phoneEmpty": "Номер телефона не может быть пустым",
    "surePasswordEmpty": "подтвердить пароль не может быть пустым",
    "userNameEmpty": "Имя пользователя не может быть пустым",
    "getCaptcha": "получить код подтверждения",
    "msgCaptcha": "СМС проверочный код",
    "prevStep": "Предыдущий",
    "surePassword": "Пожалуйста, подтвердите свой пароль",
    "reset": "Сброс",
    "resetSuccess": "Сброс успешно",
    "resetSuccessTips": "Вы успешно сбросили пароль, пожалуйста, войдите в систему",
    "loginNow": "Войти сейчас",
    "copyRight": "Авторское право принадлежит ×××××××××, Copyright @ 2020 京 ICP 备案",
    "loginFail": "Вход не выполнен. Пожалуйста попробуйте еще раз!",
    "captchaFail": "Ошибка проверки кода подтверждения",
    "failTips": "Проверка не удалась",
    "inputOrigPassword": "Пожалуйста, введите исходный пароль",
    "inputNewPassowrd": "Пожалуйста, введите новый пароль",
    "confimPassword": "Пожалуйста, подтвердите свой пароль",
    "sure": "определить",
    "cancel": "Отмена",
    "changePasswordSuccess": "пароль был обновлен",
    "continueLogin": "перерегистрировать",
    "resetLoginTips": "Вы успешно изменили свой пароль, вам нужно снова войти в систему, и вы автоматически выйдете из системы через 3 секунды.",
    "passwordFormat": "Длина пароля от 8 до 32 цифр, включая цифры, прописные и строчные буквы.",
    "changePassword": "изменить пароль",
    "poor": "слабый",
    "middle": "в",
    "strong": "Сильный",
    "logout": "Выйти успешно",
    "formerPhone": "Оригинальный номер телефона",
    "newPhone": "Новый номер телефона",
    "changePhoneSuccess": "Номер мобильного телефона успешно изменен",
    "changePhoneSuccessTips": "Вы успешно изменили свой номер телефона",
    "goHome": "Вернуться на домашнюю страницу",
    "changePhone": "Изменить номер мобильного телефона",
    "newPhoneEmpty": "Новый номер телефона не может быть пустым",
    "newPhoneFomat": "Неверный формат нового номера телефона",
    "newPhoneSupport": "Новый номер телефона не может совпадать с исходным номером телефона.",
    "newPhoneBinded": "Новый номер телефона привязан",
    "orgPhoneEmpty": "Исходный номер телефона не может быть пустым",
    "orgPhoneFormat": "Исходный формат номера телефона неверен",
    "orgPhoneNot": "Исходный номер телефона неверен",
    "resetPassword": "сбросить пароль",
    "phoneCaptchaEmpty": "Код подтверждения телефона не может быть пустым",
    "accountVerif": "Верификация учетной записи",
    "phoneVerif": "Проверка телефона",
    "resetDone": "Сброс завершен",
    "phoneFormat": "Неправильный формат номера телефона",
    "phoneBinded": "Номер мобильного телефона привязан",
    "loginVertif": "Авторизация входа",
    "clickGoHome": "Нажмите, чтобы вернуться на страницу входа",
    "bingPhoneSuccess": "Привязать номер мобильного телефона успешно",
    "rightMessageChange": "Вы можете редактировать его в личной информации в правой части панели навигации.",
    "bingPhone": "Привязать номер мобильного телефона"
  },
  "index": {
    "setAsHomePage": "Установить как главную страницу",
    "addCollection": "Добавить в избранное",
    "telephone": "горячая линия поддержки",
    "Help": "Центр помощи",
    "SystemMessage": "Системное напоминание",
    "message": "Новости",
    "emptyMessage": "Пустой",
    "checkAllMessage": "посмотреть все",
    "noMessage": "Нет данных",
    "fullScreen": "Полноэкранный дисплей",
    "ExitSystem": "Выйти из этой системы",
    "back": "возвращение",
    "top": "Топ",
    "backToTop": "Вернуться наверх",
    "homePage": "Главная",
    "course": "Курс обучения",
    "onlineCourse": "Специальный онлайн-класс",
    "faceCourse": "Очное обучение",
    "examPractice": "Экзаменационная практика",
    "dataDownLoad": "Скачать",
    "userInfo": "Персональный центр",
    "Administration": "Фон управления",
    "courseCategory": "конечно сорта",
    "examIsOver": "Оценка завершена",
    "onlineHours": "Онлайн часы",
    "faceHours": "Очные часы занятий",
    "notice": "объявление",
    "checkAllNotice": "посмотреть все",
    "backToTopButton": "Вернуться наверх",
    "recommendCourse": "Рекомендуемые курсы",
    "impotentCourse": "Ключевой курс",
    "newCourse": "Последние курсы",
    "hotCourse": "Горячий курс",
    "requiredCourses": "Обязательный курс",
    "electiveCourses": "Факультативный курс",
    "startStudy": "начать учиться",
    "continueStudy": "Продолжить",
    "coursesRanking": "Рейтинг выбора курсов",
    "studentRanking": "Рейтинг студентов",
    "currentUser": "Текущий пользователь",
    "userHead": "изображение профиля",
    "currentHead": "Текущий аватар",
    "change": "модифицировать",
    "accountPassword": "пароль от аккаунта",
    "encryPhone": "Секретный телефон",
    "currentPhone": "Текущий телефон",
    "userName": "имя пользователя",
    "head": "Аватар",
    "coverImage": "обложка",
    "uploadError": "Загрузка не удалась",
    "autoSetHomeTips": "Ваш браузер не поддерживает автоматическую настройку домашней страницы, используйте меню браузера, чтобы установить ее вручную!",
    "operateConfig": "Эта операция отклонена браузером. Если вы хотите включить эту функцию, введите about: config в адресной строке, а затем установите для параметра signed.applets.codebase_principal_support значение true.",
    "favoriteTips": "Из-за ограничений функции браузера 360 нажмите Ctrl + D, чтобы добавить закладку вручную!",
    "autoFavorite": "Ваш браузер не поддерживает это, нажмите Ctrl + D, чтобы добавить закладку вручную!",
    "required": "Этот предмет обязателен",
    "to": "к",
    "trainingTime": "период обучения",
    "coursehours": "Часы занятий",
    "human": "люди",
    "wecome": "Добро пожаловать!",
    "allCourses": "Все курсы"
  },
  "course": {
    "coursesCategory": "конечно сорта",
    "allCourses": "Все курсы",
    "electiveCourses": "Элективные курсы",
    "requiredCourses": "Обязательные курсы",
    "collect": "Избранное",
    "cancelCollect": "Удалить из избранного",
    "searchTips": "Пожалуйста, введите название курса",
    "startStudy": "начать учиться",
    "continueStudy": "Продолжить",
    "cancelConfirm": "Удалить из избранного",
    "cancelTips": "Подтвердите, чтобы отменить запрос",
    "confirmButton": "Кнопка отмены",
    "count": "Всего",
    "item": "Статья",
    "up": "Предыдущая страница",
    "next": "Следущая страница",
    "items": "Статья / Страница",
    "go": "Прыгать, чтобы",
    "page": "страница",
    "man": "люди",
    "score": "Минуты",
    "courseYear": "год",
    "courseTeachers": "учитель",
    "noDesc": "Нет введения",
    "teachersDesc": "Профиль учителя",
    "checkLog": "Просмотр записей",
    "reExam": "Повторное тестирование",
    "examLog": "Запись экзамена",
    "viewPaper": "Посмотреть тестовую статью",
    "noPublicExam": "Контрольная работа не разглашается",
    "marking": "Маркировка",
    "closeButton": "неисправность",
    "examResultPage": "Страница результатов экзамена",
    "examPage": "Страница экзамена",
    "startExam": "Начать экзамен",
    "coursehours": "Часы занятий",
    "courseInfo": "Детали курса",
    "courseChapter": "Главы курса",
    "courseNote": "Примечания к курсу",
    "courseData": "Информация о курсе",
    "courseExamination": "Экзамен",
    "evaluate": "Оценка",
    "courseEvaluate": "Оценка курса",
    "no": "Первый",
    "chapter": "глава",
    "isEvaluate": "Оценен",
    "uploadDate": "Время загрузки",
    "className": "Название класса",
    "resourceSize": "Размер ресурса",
    "times": "Раз",
    "typeViedo": "видео",
    "typeImage": "образ",
    "typeDoc": "Документация",
    "typeOuth": "Другой",
    "typeImages": "Несколько картинок",
    "newComment": "своевременно",
    "hotComment": "Самый горячий",
    "openComment": "Я хочу прокомментировать",
    "cancelButton": "Отмена",
    "publishButton": "релиз",
    "commentTips": "Пожалуйста, введите содержание комментария",
    "emptyCommentTips": "Содержание комментария не может быть пустым",
    "noteSource": "От",
    "deleteNoteButton": "удалять",
    "needIETips": "Для текущего учебного курса требуется браузер IE!",
    "donwNum": "время загрузки",
    "preview": "Предварительный просмотр",
    "relatedCourses": "Связанные курсы",
    "studentsNum": "Количество курсов",
    "courseHours": "Часы курса",
    "JoinLearning": "Присоединяйтесь к обучению"
  },
  "onlineclass": {
    "allTheClass": "Все классы",
    "beginClass": "Занятия начались",
    "notBeginClass": "Нет класса",
    "endClass": "Закрыто",
    "searchThoseClass": "Найдите в Интернете интересующий вас специальный класс",
    "startLearn": "Войти в класс",
    "registrationTime": "время регистрации",
    "to": "к",
    "trainingTime": "период обучения",
    "subjectsClass": "Курсы",
    "classStudy": "Учеба в классе",
    "quantityOfCourses": "Количество курсов",
    "numberOfParticipants": "Кол-во претендентов",
    "registerNow": "зарегистрируйтесь сейчас",
    "resetRegister": "Отозвать имя",
    "participating": "Участвовали",
    "subjects": "дверь",
    "classExam": "Классный экзамен",
    "notParticipat": "Не участвует",
    "startExim": "Начать экзамен",
    "handed": "выполнять задание",
    "score": "Гол",
    "cacheSave": "Временное хранилище",
    "subjectsNumber": "Количество дверей",
    "notice": "Уведомление",
    "communication": "общение",
    "detail": "Детали",
    "courses": "курс",
    "allClass": "Все",
    "compulsory": "Обязательный",
    "elective": "Выборный",
    "Learned": "Научился",
    "classPassIndicator": "Индикаторы прохождения класса",
    "excellence": "превосходно",
    "compulsoryNumber": "Количество необходимых проходов",
    "electiveNumber": "Количество сданных факультативов",
    "compulsoryStandard": "Обязательные стандартные часы",
    "electiveStandard": "Факультативные часы",
    "examIsPass": "Сдан ли экзамен",
    "resource": "Ресурсы",
    "source": "данные",
    "new": "своевременно",
    "hot": "Самый горячий",
    "updateTime": "Время загрузки",
    "downloadCount": "Загрузки",
    "download": "скачать",
    "resourceSize": "Размер ресурса",
    "resourceType": "Типы",
    "allType": "Все типы",
    "videos": "видео",
    "images": "образ",
    "document": "Документация",
    "others": "Другой",
    "multiImages": "Несколько картинок",
    "inforCertificate": "свидетельство",
    "notSubmit": "неподтвержденный",
    "submitHomework": "отправить домашнее задание",
    "submitTime": "Время подачи",
    "uploadHomework": "Загрузить задание",
    "clickHere": "кликните сюда",
    "upload": "Загрузить",
    "formatSupport": "Поддержка форматов файлов",
    "submited": "Отправлено",
    "notApproved": "Непроверенный",
    "approved": "экзамен сдан",
    "downloadHomework": "Скачать задание",
    "reSubmit": "Отправить повторно",
    "myScore": "Мой счет",
    "comments": "Комментарии",
    "talk": "обсудить",
    "category": "классификация",
    "classTalk": "Обсуждение в классе",
    "groupTalk": "групповая дискуссия",
    "wantTalk": "Я хочу обсудить",
    "publish": "релиз",
    "undo": "Отмена",
    "delete": "удалять",
    "iknow": "я понял",
    "faceCourseClass": "Очное обучение",
    "onlineClasses": "Специальный онлайн-класс",
    "openReservation": "Открыта для регистрации",
    "talkTech": "лектор",
    "address": "место расположения",
    "up": "на",
    "noon": "Полдень",
    "down": "под",
    "even": "поздно",
    "classOvered": "Класс закрыт",
    "nopassed": "Еще не зарегистрирован",
    "inputTalkContent": "Пожалуйста, введите содержание обсуждения",
    "groupMan": "Лидер группы",
    "showAllGroup": "Просмотреть всех участников",
    "hideAllGroup": "Уберите всех членов команды",
    "showAllMan": "Просмотреть всех студентов",
    "hideAllMan": "Уберите всех студентов",
    "reply": "Ответить",
    "isDelete": "Вы уверены, что хотите удалить?",
    "cancelLike": "В отличие от",
    "classNotStar": "Регистрация класса еще не началась",
    "classIsEnd": "Регистрация класса закончилась",
    "clickReset": "Нажмите кнопку, чтобы отозвать имя",
    "agentRegister": "Зарегистрируйтесь снова",
    "cancelRegister": "Отменить регистрацию",
    "reason": "причина",
    "inputReason": "Пожалуйста, введите причину отзыва",
    "homework": "операция",
    "leaveMaxBits": "Причина запроса отпуска не может превышать 100 слов.",
    "leaveNotEndTime": "Время начала отпуска не может совпадать со временем окончания",
    "sizeNot": "Размер не может превышать",
    "close": "неисправность",
    "teacher": "учитель",
    "noIntroduction": "Нет введения"
  },
  "offlineclass": {
    "fullTimeToFace": "Очное очное обучение",
    "onlineToFace": "На работе",
    "allClass": "Все классы",
    "openClass": "Открытый класс",
    "searchThoseClass": "Найдите интересующие вас курсы очного обучения",
    "startLearn": "Введите обучение",
    "classHours": "Часы занятий",
    "h": "Время",
    "firstWeek": "1 неделя",
    "askLeave": "Я хочу уйти",
    "monday": "понедельник",
    "tuesday": "вторник",
    "wednesday": "Среда",
    "thursday": "Четверг",
    "fridays": "Пятница",
    "saturdays": "в субботу",
    "sunday": "В воскресенье",
    "morning": "утро",
    "afternoon": "после обеда",
    "evening": "ночью, вечером",
    "leaveType": "Тип отпуска",
    "selectLeaveType": "Пожалуйста, выберите тип отпуска",
    "leaveTime": "Нет больше времени",
    "selctLeaveTime": "Пожалуйста, выберите время отпуска",
    "reasonLeave": "Причина отпуска",
    "inputReasonLeave": "Пожалуйста, введите причину отпуска",
    "sure": "определить",
    "selectTime": "период отбора",
    "casualLeave": "Личный отпуск",
    "sickLeave": "больничный",
    "seven": "день",
    "one": "Один",
    "two": "два",
    "three": "три",
    "for": "четыре",
    "five": "Пятерки",
    "six": "шесть",
    "clear": "Пустой",
    "evaluating": "Оценка",
    "courseEvaluation": "Оценка обучения",
    "inputEvaluating": "Пожалуйста, введите содержание экзамена",
    "beDoing": "В ходе выполнения",
    "notStarted": "не началось",
    "evaluationInProgress": "Оценка в процессе",
    "notEvaluation": "Не оценивается",
    "evaluationStartTime": "Время начала оценки",
    "startEvaluation": "Начать оценку",
    "classEvaluation": "Оценка класса",
    "photoCategory": "Классификация альбомов",
    "learningActivity": "Учебная деятельность",
    "addPhoto": "Новые добавленные фото",
    "photoMessage": "Информация о фото",
    "photoName": "Название фото",
    "inputPhotoName": "Пожалуйста, введите название фотографии",
    "uploadPhoto": "Загрузить фото",
    "formatSupport": "Поддержка формата поддержки",
    "tickets": "Чжан",
    "group": "группа",
    "notGroup": "несекретный",
    "groupTalk": "Групповая дискуссия",
    "teacherAbout": "Профиль учителя",
    "teacherTech": "Курсы пройдены",
    "photos": "Фотоальбом",
    "phontoRequier": "Фотографии должны быть загружены",
    "addPhoneTips": "Добавлено успешно, дождитесь проверки",
    "sureDelete": "Вы уверены, что хотите удалить",
    "deleteSuccess": "успешно удален",
    "phoneNameReq": "Поле имени фотографии обязательно",
    "longNotBits": "Длина не может превышать 50 символов.",
    "phoneIsOccur": "Название фотографии уже существует",
    "evaluateTime": "Время оценки",
    "evalueteNotStar": "Оценка не началась",
    "evaluateEnds": "Оценка закончилась",
    "isEvaluated": "Оценено",
    "at": "в",
    "submit": "Отправить",
    "seeEvalute": "Посмотреть оценку",
    "inputIdea": "Пожалуйста, введите свои мысли",
    "submitFailure": "Не удалось сдать",
    "seeRecord": "Просмотр записей",
    "examRecord": "Запись экзамена",
    "seeSubmite": "Посмотреть тестовую статью",
    "resultPage": "Страница результатов экзамена",
    "hoursStandard": "Не может сдать экзамен, если часы занятий не соответствуют норме",
    "examPage": "Страница экзамена",
    "questionnaire": "Анкета",
    " coursesTaught": "Преподаваемые курсы",
    "passed": "по",
    "is": "да",
    "not": "нет",
    "passedState": "Статус прохождения",
    "sketch": "проект",
    "partySchool": "Учебный класс партийной школы",
    "searchPartySchool": "Найдите интересующий вас класс партийной школы"
  },
  "exam": {
    "answerWarning": "Вопрос этого экзамена является необратимым для одного вопроса, пожалуйста, будьте осторожны перед следующим вопросом",
    "inputAnswerTips": "Пожалуйста, введите свой ответ",
    "problemPoints": "Анализ проблемы",
    "examination": "Зарегистрироваться на экзамен",
    "knowledgeCompetition": "Конкурс знаний",
    "practice": "Автономная практика",
    "notRegister": "Не зарегистрирован",
    "reviewAudit": "на рассмотрении",
    "auditNoPass": "Аудит не прошел",
    "participanted": "зарегистрированный",
    "participant": "зарегистрироваться",
    "examTime": "время экзамена",
    "examHours": "продолжительность",
    "registration": "Зарегистрируйтесь успешно",
    "reRegistration": "Отозвать имя",
    "wrongQuestion": "Неправильный банк вопросов",
    "noInvolvement": "Не участвует",
    "involvement": "Принимала участие",
    "searchExamPractice": "Ищите экзамены и упражнения, которые вас интересуют",
    "practiced": "Практиковал",
    "startPractice": "Начать практиковаться",
    "toFavorite": "Добавить в избранное",
    "prevPrevious": "Предыдущий вопрос",
    "nextPrevious": "Следующий вопрос",
    "submitAnswers": "Отправить ответ",
    "rightAnswers": "правильный ответ",
    "yourAnswers": "ваш ответ",
    "questionsAnalysis": "Анализ вопросов",
    "noAnalysis": "Нет разрешения",
    "accuracy": "Правильная ставка",
    "continuePracticed": "Продолжай практиковаться",
    "topics": "тема"
  },
  "source": {
    "allResource": "Все ресурсы",
    "commonResource": "Общие ресурсы",
    "classResource": "Ресурсы класса",
    "resourceCategory": "Классификация ресурсов",
    "searchResource": "Найдите интересующие вас ресурсы",
    "resourceTalk": "Оценка ресурсов",
    "previewResource": "Предварительный просмотр ресурса",
    "helpPoint": "Справочное руководство",
    "isEvaluation": "Вы уже оценили!",
    "selectEvaluation": "Вы не выбрали рейтинг!",
    "evaluationSuccess": "Успешная оценка",
    "topRelise": "верхний",
    "className": "Название класса",
    "resourceEvaluation": "Рейтинг ресурсов"
  },
  "usercenter": {
    "386": "Учебный файл",
    "myCourse": "Мои курсы",
    "hours": "Время",
    "loginAccount": "Вход в аккаунт",
    "htllo": "Здравствуйте",
    "welcomeMessage": "Желаю тебе счастья каждый день",
    "underway": "Ты делаешь",
    "annualAssessment": "Ежегодная оценка",
    "searchTips": "Введите название искомого курса",
    "completed": "Законченный",
    "allCourses": "Все курсы",
    "requiredCourses": "Обязательные курсы",
    "electiveCourses": "Элективные курсы",
    "all": "Все",
    "ongoing": "обработка",
    "learnTo": "Учиться",
    "inExams": "Пройти тест",
    "noExams": "Без экзамена",
    "delete": "удалять",
    "pleaseSelect": "пожалуйста, выберите",
    "searchOnlineTips": "Найдите в Интернете интересующие вас специальные курсы",
    "passedCourse": "прошло",
    "failedCourse": "Не прошел",
    "myOnlineCourse": "Мой специальный онлайн-класс",
    "myFaceCourse": "Мой очный тренинг",
    "searchFaceTips": "Найдите интересующие вас курсы",
    "myExams": "Мой экзамен",
    "allExams": "Все экзамены",
    "makeUpExam": "Быть составленным",
    "marking": "Маркировка",
    "onExam": "Идет экзамен",
    "passedExam": "Экзамен сдан",
    "examHours": "Продолжительность теста",
    "examOver": "Экзамен окончен",
    "exam": "осмотр",
    "examLog": "Запись экзамена",
    "myScore": "Мой счет",
    "surplusMakeUpExam": "Оставшийся осмотр макияжа",
    "times": "Раз",
    "searchExamTips": "Введите название поиска",
    "haveTime": "Время вышло",
    "question": "вопрос",
    "eachQuestion": "Каждый вопрос",
    "score": "Минуты",
    "examExplain": "Описание экзамена",
    "confirmHandExams": "Подтвердить ли отправку",
    "autoSaveFailed": "Ошибка автосохранения",
    "autoSaveSuccess": "Автосохранение",
    "handExamsSuccess": "Успешно сдано",
    "yourScore": "Твой счет",
    "noPublicAnswers": "Ответы на этот экзамен объявляться не будут",
    "noPublicResult": "Контрольная работа не разглашается",
    "reExam": "Повторное тестирование",
    "practice": "Упражнение",
    "hasCollected": "собраны",
    "emptyAnswer": "Содержание варианта или ответа не может быть пустым",
    "isCorrect": "Положительное решение",
    "myCollected": "моя коллекция",
    "courseCollected": "Коллекция курсов",
    "examCollected": "Контрольные вопросы",
    "deleteCollected": "Удалить избранное",
    "myLeave": "Мой отпуск",
    "allLeave": "Все уходят",
    "needAudit": "В ожидании",
    "auditDate": "время подачи заявки",
    "searchLeaveTips": "Найдите интересующий отпуск",
    "checkInfo": "смотрите подробности",
    "cancelLeave": "Отменить отпуск",
    "leaveInfo": "Оставьте детали",
    "leaveState": "Текущее состояние",
    "teamLeader": "Лидер группы",
    "committeeMembers": "Комитет по проверке дисциплины организации",
    "headmaster": "директор школы",
    "schoolLeader": "Руководитель школы",
    "student": "Стажер",
    "auditMessage": "Причина утверждения",
    "onBusiness": "Для бизнеса",
    "personal": "Для личной выгоды",
    "rejectReasons": "Причина отказа",
    "confirmCancel": "Подтвердите, отменять ли отпуск",
    "cancelButton": "Отозвать",
    "cancelTitle": "Подтверждение отзыва",
    "empty": "нет",
    "wrongQuestionBank": "Мой неправильный банк вопросов",
    "searchWrongTips": "Ищите не тот вопрос, который вас интересует",
    "deleteWrongQuestion": "Удалите неправильный банк вопросов",
    "myQuestionnaire": "Моя анкета",
    "isCompleted": "завершено",
    "isOver": "над",
    "searchQuestionnaireTips": "Введите название поисковой анкеты",
    "questionnaireDate": "Время анкетирования",
    "startQuestionnaire": "Начать отвечать",
    "checkQuestionnaire": "Посмотреть анкету",
    "allTeacher": "Все учителя",
    "newTeacher": "Добавить учителя",
    "searchTeacherTips": "Найдите интересующих вас учителей",
    "checkTeacher": "Посмотреть",
    "editTeacher": "редактировать",
    "workingIn": "Работал над",
    "location": "Постоянное местонахождение",
    "confirmDelete": "Удалить подтверждение",
    "confirmDeleteTips": "Подтвердите удаление",
    "recommendTeacher": "Рекомендация учителя",
    "addTeachers": "Новые учителя",
    "teacherInfo": "Личная информация * Персональная информация",
    "teacherName": "Имя учителя",
    "workUnit": "Работодатель",
    "contact": "Контактная информация",
    "teacherNameTips": "Пожалуйста, введите имя учителя",
    "teacherWorkUnitTips": "Пожалуйста, укажите работодателя",
    "teacherContactTips": "Пожалуйста, введите контактную информацию учителя",
    "teacherLocationTips": "Пожалуйста, введите постоянное местонахождение",
    "teacherDescTips": "Пожалуйста, введите профиль учителя",
    "teachingInfo": "Учебная информация",
    "teachingExpertise": "Опыт преподавания",
    "fitLevel": "Подходит для обучения объектному уровню",
    "fitBusiness": "Подходит для бизнес-направлений",
    "ruleNumber": "Пожалуйста, введите целое число до 8 цифр (включая 8)",
    "rulePhone": "Пожалуйста, введите действующий телефонный номер",
    "ruleString": "Пожалуйста, введите 80 символов (включая 80)",
    "ruleIsNumber": "Пожалуйста, введите номер",
    "pause": "Временное хранилище",
    "teachingStyle": "Стиль лекции",
    "teachingExpertiseTips": "Пожалуйста, укажите педагогический опыт учителя",
    "fitLevelTips": "Выберите уровень, который подходит целевой аудитории",
    "fitBusinessTips": "Выберите подходящее направление деятельности",
    "chargeInfoTips": "Пожалуйста, введите стандарт зарядки",
    "teachingStyleTips": "Пожалуйста, введите стиль лекции учителя",
    "otherInfo": "Другая информация",
    "recommendUnit": "Рекомендовано",
    "otherOption": "Прочие вопросы",
    "otherOptionTips": "Пожалуйста, введите другие вещи, которые необходимо добавить",
    "isRequired": "Этот предмет обязателен",
    "pauseSuccess": "Успешно сохранено",
    "phoneWrong": "Пожалуйста, введите действующий телефонный номер",
    "junior": "Младший школьник",
    "highSchool": "Студент Высшей школы",
    "english": "английский",
    "mathematics": "математика",
    "recommendSuccessTips": "Вы успешно отправили рекомендованного учителя. После проверки он будет добавлен в пул учителей.",
    "goBackrecommend": "Вернуться к рекомендации учителя",
    "checkTeacherInfo": "Посмотреть учителей",
    "currentState": "Текущее состояние",
    "chargeInfo": "Сборы",
    "myCertificate": "Мой сертификат",
    "learningArchives": "Учебный файл",
    "allCertificate": "Все сертификаты",
    "onlineCourse": "Онлайн-класс",
    "faceCourse": "Очное занятие",
    "exams": "осмотр",
    "baseInfo": "основная информация",
    "userName": "имя пользователя",
    "name": "имя",
    "company": "Текущий блок",
    "learningExperience": "История изучения",
    "assessmentIndex": "Индекс оценки",
    "assessmentStatus": "Статус оценки",
    "assessmentTime": "время теста",
    "onlineLearning": "Онлайн обучение",
    "year": "год",
    "faceOutProduceHours": "Личное обучение (часы занятий)",
    "notFaceOutProduceHours": "Очное обучение не очное (часы занятий)",
    "onlineCenterLearnHours": "Интенсивное онлайн-обучение (часы занятий)",
    "onlineSelfLearnHours": "Самообучение онлайн (часы занятий)",
    "outCompanyLearnHours": "Обучение за рубежом (часы занятий)",
    "allHours": "общий период",
    "onlineSelfLearn": "Автономное онлайн-обучение",
    "onlineCentralizedLearning": "Интенсивное онлайн-обучение",
    "outCompanyLearn": "Исследование иностранных единиц",
    "faceTrain": "Очное обучение",
    "myNotice": "Мое сообщение",
    "noticeSearchTips": "Найдите интересующие вас новости",
    "systemNotice": "Системное напоминание",
    "message": "Личное письмо"
  },
  "questionnaire": {
    "notParticipat": "Не участвует",
    "description": "Описание анкеты",
    "save": "спасти",
    "export": "Экспорт",
    "printing": "Распечатать",
    "handed": "выполнять задание",
    "topics": "тема",
    "examList": "Список тестовых вопросов",
    "tableQuestions": "Стол вопрос",
    "newLine": "Добавить ряд",
    "deleteLine": "Удалить строку",
    "sort": "Серийный номер",
    "content": "содержание",
    "shortQuestion": "Короткий ответ",
    "inputContent": "Пожалуйста, введите содержание ответа",
    "multiple": "Множественный выбор",
    "single": "Множественный выбор",
    "saveSuccess": "Успешно сохранено",
    "submitSuccess": "Отправлено успешно",
    "submitTips": "Вы успешно отправили анкету, спасибо за участие",
    "closePage": "Закрыть эту страницу"
  },
  "play": {
    "endStudy": "Конец учебы",
    "tips": "подсказки",
    "playTips": "Напоминание: чтобы обеспечить нормальный учет вашего учебного времени системой, нажмите кнопку «Завершить исследование» в правом верхнем углу, чтобы выйти из исследования. Если вы напрямую закроете браузер, ваше учебное время может не записываться нормально.",
    "notShowAgain": "Больше не выводить это сообщение",
    "gotIt": "я понял",
    "chapter": "глава",
    "chapterText1": "Первый",
    "chapterText2": "глава",
    "note": "заметки",
    "noteBlockTitle": "заметки",
    "evaluate": "Оценка",
    "evaluateStar": "звезда",
    "saveEvaluate": "Отправить",
    "notePlaceholder": "Пожалуйста, введите примечания",
    "closeTips": "Система может не сохранять ваши изменения",
    "closeButton": "уходи",
    "autoStop": "Прекратить играть автоматически",
    "autoStopTips": "Поскольку вы давно не работали, система автоматически остановила воспроизведение видео.",
    "confirmOut": "Вы уверены, что бросите играть?",
    "closeOrNot": "Закрывать ли текущее окно",
    "noCoursePlay": "В текущем курсе нет игровых программ",
    "attention": "Пожалуйста, обратите внимание!"
  }
};